export default __webpack_public_path__ + "static/project-management-fr-f7e044e3c46fa7730d2fddeb2b9711d9.webp";